/**
 * Turns part / whole into a rounded percent like "56%". Tiny shares show as "<1%" and near-complete ones as ">99%",
 * so they never round to 0% or 100%. Returns null when whole is 0.
 */
export const formatPercent = (part: number, whole: number): string | null => {
  if (whole === 0) {
    return null;
  }
  const fraction = part / whole;
  if (fraction > 0 && fraction < 0.01) {
    return '<1%';
  }
  if (fraction > 0.99 && fraction < 1) {
    return '>99%';
  }
  return `${Math.round(fraction * 100)}%`;
};
